import { FC } from 'react';
import {
    useTranslate,
    ReferenceManyField,
    Datagrid,
    DateField,
    NumberField,
} from 'react-admin';
import {
    makeStyles,
    createStyles,
    Theme,
    Grid,
    // useMediaQuery,
    Typography,
} from '@material-ui/core';
import CustomNumberField from '../components/customNumber';
import { dateLocales, currencyFormatter, percentFormatter, defaultDateOptions } from '../utils/formatters';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        fixed_fee: {},
        amount: { fontWeight: 'bold' },
        dataGrid: {
            // width: '50%'
        }

    })
)

const ConciliationTransactionsTable: FC<{}> = (props) => {
    const translate = useTranslate()
    const classes = useStyles()

    // const isMedium = useMediaQuery<Theme>(theme =>
    //     theme.breakpoints.down('md')
    // );
    // const isSmall = useMediaQuery<Theme>(theme =>
    //     theme.breakpoints.down('sm')
    // );

    return <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>{translate("resources.Transaction.fields.conciliationTransaction")}</Typography>
        <ReferenceManyField
            reference="ConciliationTransaction"
            target="transaction_id"
        >
            {/* {isSmall ? // Change of responsive design */}
            {/* // <SimpleList
                //     primaryText={record => `Pago ${record.id}`}
                //     secondaryText={record => `Amount ${currencyFormatter().format(record.amount / 100)}`}
                //     tertiaryText={record => `FF: ${(record.fixed_fee / 100)}% RR: ${(record.repayment_rate / 100)}%`}
                //     linkType={record => record.canEdit ? "edit" : "show"}
                //     leftIcon={record => <financings.icon />}
                // // rowStyle={postRowStyle}
                // />
                // : */}
            <Datagrid className={classes.dataGrid} optimized>
                <NumberField source="id" />
                <DateField source="timestamp" locales={dateLocales} options={defaultDateOptions} />
                {/* {!isMedium && <DateField source="created_at" locales={dateLocales} options={defaultDateOptions} />} */}
                {/* {!isMedium && <DateField source="updated_at" locales={dateLocales} options={defaultDateOptions} />} */}
                <CustomNumberField
                    source="gross_sales"
                    divisor={100}
                    className={classes.amount}
                    locales="en-US"
                    options={currencyFormatter().resolvedOptions()}
                />
                <CustomNumberField
                    source="expected_deposit"
                    divisor={100}
                    className={classes.amount}
                    locales="en-US"
                    options={currencyFormatter().resolvedOptions()}
                />
                <CustomNumberField
                    source="actual_deposit"
                    divisor={100}
                    className={classes.amount}
                    locales="en-US"
                    options={currencyFormatter().resolvedOptions()}
                />
                <CustomNumberField
                    source="repayment"
                    divisor={100}
                    className={classes.amount}
                    locales="en-US"
                    options={currencyFormatter().resolvedOptions()}
                />
                <CustomNumberField
                    source="balance"
                    divisor={100}
                    className={classes.amount}
                    locales="en-US"
                    withNegatives={true}
                    options={currencyFormatter().resolvedOptions()}
                />
                <CustomNumberField
                    source="repayment_rate"
                    divisor={10000}
                    className={classes.amount}
                    locales="en-US"
                    options={percentFormatter().resolvedOptions()}
                />
            </Datagrid>
            {/* } */}
        </ReferenceManyField>
    </Grid>
}


export default ConciliationTransactionsTable